import "./table-tools.component.scoped.sass";
import React from "react";
import { TableToolsProps } from "../../types/table-tools-props";
import { icons } from "../../statics/icons";
import { useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";

export const TableToolsComponent = (props: TableToolsProps) => {
  const [t] = useTranslation();
  const { refresh, print, exportCsv } = props.tools;
  const { withRefresh, withExport, withPrint } = props.options;
  const { refreshIco, printIco, exportIco } = icons;
  return (
    <div className="table-tools">
      {withRefresh && (
        <Button
          variant="outlined"
          className="btn-tool border-light-blue text-blue mr-13-px"
          onClick={refresh}
        >
          <img alt="icon" className="icon icon-refresh" src={refreshIco} />
          <span className="hide-on-mobile">{t("refresh")}</span>
        </Button>
      )}
      {withPrint && (
        <Button
          variant="outlined"
          className="btn-tool border-light-blue text-blue mr-13-px"
          onClick={print}
        >
          <img alt="icon" className="icon icon-refresh" src={printIco} />
          <span className="hide-on-mobile">{t("print")}</span>
        </Button>
      )}
      {withExport && (
        <Button
          variant="contained"
          className="btn-tool btn-export"
          onClick={exportCsv}
        >
          <img alt="icon" className="icon icon-refresh" src={exportIco} />
          <span className="hide-on-mobile">{t("export")}</span>
        </Button>
      )}
    </div>
  );
};
